import { render, staticRenderFns } from "./MemberDirectory.vue?vue&type=template&id=24ff0402"
import script from "./MemberDirectory.vue?vue&type=script&lang=js"
export * from "./MemberDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports